module.exports = __webpack_public_path__ + "img/GRG.294c3b2c.jpg";